module.exports = __webpack_public_path__ + "img/CAimgs.6c00e8e2.png";